import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-draaikiepraam-reparatie"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Draaikiepraam reparatie"
    />
  );
}